import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/auth";
import roleReducer from '../features/roles/role'
import invitationReducer from '../features/invitations/invitation'
import userReducer from '../features/users/users'
import blockReducer from '../features/blocks/blocks'
import permissionReducer from '../features/permissions/permissions'
import clientReducer from '../features/clients/client'
import fieldReducer from "../features/fields/fields"
import recordReducer from "../features/records/records"
import themeReducer from "../features/theme/theme"
import reportsReducer from "../features/reports/reports"
import warehouseReducer from "../features/warehouse/warehouseSlice";
import inventoryReducer from "../features/inventory/Inventoryslice";
import inboundReducer from '../features/inbound/Inboundslice';
import orderManagementReducer from '../features/ordermanagement/Ordermanagementslice';
import dispatchReducer from '../features/Dispatch/Dispatchslice';
import stockMovementReducer from '../features/Stockmovement/Stockmovementslice';
import inventoryAuditReportReducer from '../features/Inventoryauditreport/Inventoryauditreportslice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    role: roleReducer,
    invitation: invitationReducer,
    permission: permissionReducer,
    block: blockReducer,
    user: userReducer,
    client: clientReducer,
    field: fieldReducer,
    record: recordReducer,
    theme: themeReducer,
    report: reportsReducer,
    warehouse: warehouseReducer,
    inventory: inventoryReducer,
    inbound: inboundReducer,
    orderManagement: orderManagementReducer,
    dispatch: dispatchReducer,
    stockMovement: stockMovementReducer,
    inventoryAuditReport: inventoryAuditReportReducer,
  }
});